import React, { useEffect, useRef } from "react";

const SITE_KEY = process.env.REACT_APP_CLOUDFLARE_TURNSTILE_SITE_KEY?.trim() || "";

/**
 * Optional Cloudflare Turnstile widget.
 * Renders nothing when REACT_APP_CLOUDFLARE_TURNSTILE_SITE_KEY is unset.
 */
export default function TurnstileWidget({ onTokenChange }) {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);
  const onTokenChangeRef = useRef(onTokenChange);
  onTokenChangeRef.current = onTokenChange;

  useEffect(() => {
    if (!SITE_KEY || !containerRef.current) {
      onTokenChangeRef.current?.(undefined);
      return undefined;
    }

    const onSuccess = (token) => {
      onTokenChangeRef.current?.(token);
    };
    const onExpire = () => {
      onTokenChangeRef.current?.(undefined);
    };

    const renderWidget = () => {
      if (!window.turnstile || !containerRef.current) return;
      if (widgetIdRef.current !== null) {
        try {
          window.turnstile.remove(widgetIdRef.current);
        } catch {
          // ignore
        }
      }
      widgetIdRef.current = window.turnstile.render(containerRef.current, {
        sitekey: SITE_KEY,
        callback: onSuccess,
        "expired-callback": onExpire,
        "error-callback": onExpire,
        theme: "light",
      });
    };

    if (window.turnstile) {
      renderWidget();
      return () => {
        if (widgetIdRef.current !== null && window.turnstile) {
          try {
            window.turnstile.remove(widgetIdRef.current);
          } catch {
            // ignore
          }
        }
      };
    }

    let script = document.querySelector("script[data-solvtax-turnstile]");
    if (!script) {
      script = document.createElement("script");
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      script.dataset.solvtaxTurnstile = "1";
      document.body.appendChild(script);
    }
    script.addEventListener("load", renderWidget);
    if (window.turnstile) renderWidget();

    return () => {
      script.removeEventListener("load", renderWidget);
      if (widgetIdRef.current !== null && window.turnstile) {
        try {
          window.turnstile.remove(widgetIdRef.current);
        } catch {
          // ignore
        }
      }
    };
  }, []);

  if (!SITE_KEY) return null;

  return <div ref={containerRef} className="flex justify-center my-2" />;
}

export const isTurnstileRequired = () => Boolean(SITE_KEY);
